import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { tournamentConverter } from './converters';
import type { Tournament } from './types';

export function useTournaments(ownerUid: string | null | undefined): {
  tournaments: Tournament[] | undefined;
  error: Error | null;
} {
  const [tournaments, setTournaments] = useState<Tournament[] | undefined>(undefined);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!ownerUid) {
      setTournaments([]);
      return;
    }
    const q = query(
      collection(db, 'tournaments'),
      where('ownerUid', '==', ownerUid),
      orderBy('date', 'desc')
    ).withConverter(tournamentConverter);

    return onSnapshot(
      q,
      (snap) => setTournaments(snap.docs.map((d) => d.data())),
      (err) => setError(err)
    );
  }, [ownerUid]);

  return { tournaments, error };
}
